<script lang="ts">
  import { ContactUs } from '@widgets/contact-us';
  import type { PageData } from './$types';

  export let data: PageData;
</script>

<ContactUs {data} />
